import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { FormspreeProvider } from '@formspree/react';

ReactDOM.render(
  <React.StrictMode>
    <FormspreeProvider project="{paiva}">
      <App />
    </FormspreeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
